import { render, staticRenderFns } from "./PublicShareAuthRequestPasswordButton.vue?vue&type=template&id=1ffb88f8&scoped=true&"
import script from "./PublicShareAuthRequestPasswordButton.vue?vue&type=script&lang=js&"
export * from "./PublicShareAuthRequestPasswordButton.vue?vue&type=script&lang=js&"
import style0 from "./PublicShareAuthRequestPasswordButton.vue?vue&type=style&index=0&id=1ffb88f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb88f8",
  null
  
)

export default component.exports